import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import Modal from 'react-native-modal';
import { Button, Text } from '~/components';
import type { SvgProps } from 'react-native-svg';
import CloseSVG from '~/assets/svgs/close.svg';
import colors from '~/assets/themes/colors';

interface Props {
  title: string;
  description: string;
  icon: React.FC<SvgProps>;
  visible: boolean;
  onDismiss: () => void;
}

const HelpModal = ({
  title,
  description,
  icon: Icon,
  visible,
  onDismiss,
}: Props) => {
  return (
    <Modal
      isVisible={visible}
      className="m-0 justify-end"
      onBackdropPress={onDismiss}
      onBackButtonPress={onDismiss}
      onSwipeComplete={onDismiss}
      swipeDirection={['down']}
      propagateSwipe
    >
      <View className="bg-white p-7 rounded-t-2xl items-center">
        <View>
          <View className="w-10 h-1 bg-dark-400 rounded mb-10" />
        </View>

        <TouchableOpacity
          activeOpacity={0.6}
          className="absolute top-4 right-6"
          onPress={onDismiss}
        >
          <CloseSVG color={colors.dark[400]} height={30} width={30} />
        </TouchableOpacity>

        <View className="h-[120px] w-[120px] bg-secondary-200 rounded-[60px] mb-6 items-center justify-center">
          <Icon height={58} width={58} />
        </View>

        <Text className="text-center text-xl mb-4">{title}</Text>

        <Text className="text-sm text-gray-400 text-center mb-8">
          {description}
        </Text>
      </View>

      <View className="px-6 py-4 bg-white pb-6 border-t border-t-light-200">
        <Button onPress={onDismiss}>Entendi</Button>
      </View>
    </Modal>
  );
};

export default HelpModal;
